/*
 * @Author: 赵大壮 372839241@qq.com
 * @Date: 2025-08-24 21:27:23
 * @LastEditors: 赵大壮 372839241@qq.com
 * @LastEditTime: 2026-04-13 02:43:23
 * @FilePath: \利享乡村管理后台\src\views\审核管理\view\需求管理\Index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { Component, Vue, Inject } from "vue-property-decorator";
import DZServiceDemand from "@/views/审核管理/service/DZServiceDemand";
import nyNetwork from "@/api/nyBaseNetwork";
import DZSearchDemand from "@/views/审核管理/model/search/DZSearchDemand";
import ny_config from "@/api/nyConfig";
import api from "@/api/nyApiJson";

@Component({
    components: {}
})
export default class Index extends Vue {

    $refs: any;

    table_height = 0;

    serve = new DZServiceDemand();

    excelName = '需求列表';

    json_fields = {
        '信息标题': 'title',
        '详细地址': 'addressInfo',
        '土地价格': 'priceInfo',
        '面积': 'areaInfo',
        '发布状态': 'status',
    }
    activeName = 'A'

    toPrint() {
        this.$nyPrint.printTable(this.selections, this.json_fields, this.excelName)
    }

    created() {
        this.action_page_demand()
    }

    mounted() {
        this.$nextTick(() => {
            const mainHeight = this.$refs.mainContent.offsetHeight;
            console.log("mainHeight", mainHeight)
            const mainScreen = this.$refs.mainScreen.offsetHeight;
            console.log("mainScreen", mainScreen)
            this.table_height = mainHeight - mainScreen - 130;
        })
    }
    bindImage(id) {
        if (!id) {
            return "";
        }
        let apiName = "显示图片";
        let apiJson: ny_config = api[apiName];
        let url = apiJson.baseUrl + apiJson.url + "?image=" + id
        console.log(url)
        return url;
    }
    action_page_demand() {

        this.serve.net_page_demand()
    }

    handle_edit(id) {
        this.$router.push({ path: "/demand/info", query: { id: id } })
    }

    //发布状态：0-待审核，1-待交易，2-审核未通过，3-暂停，4-已过期，5-已交易
    bindStatus(status) {
        switch (status) {
            case 0: return "待审核";
            case 1: return "待交易";
            case 2: return "审核未通过";
            case 3: return "暂停发布";
            case 4: return "已过期";
            case 5: return "已交易";
            default: return status
        }
    }

    selections = []
    handleSelectionChange(val) {
        val.map(v => {
            v.status = this.bindStatus(v.status)
        })
        this.selections = val;
    }

    // 操作 a-通过 b-拒绝 c-暂停 d-继续
    handleCommand(id, event) {
        switch (event) {
            case "a":
                this.serve.net_demand_pass(id, this.action_page_demand)
                return
            case "b":
                this.serve.net_demand_refuse(id, this.action_page_demand)
                return
            case "c":
                this.serve.net_demand_operate(id, this.action_page_demand)
                return
            case "d":
                this.serve.net_demand_operate(id, this.action_page_demand)
                return
            default: return;
        }
    }

    el_cascader_props = {
        lazy: true,
        checkStrictly: true,
        lazyLoad(node, resolve) {
            const { level, value } = node;
            let id = 0
            if (level != 0) {
                id = value
            }
            nyNetwork.net("城市子列表", { pid: id }, data => {
                const nodes = data.map(i => {
                    return {
                        value: i.id,
                        label: i.name,
                        leaf: level >= 2
                    }
                })
                resolve(nodes)
            })
        }
    }

    clean() {
        this.serve.m_search = new DZSearchDemand(10);
        this.action_page_demand()
    }

    handleDbClick(row) {
        if (row.id) {
            this.handle_edit(row.id)
        }
    }

    handleSizeChange(val) {
        this.serve.m_search.pageSize = val
        this.action_page_demand()
    }

    toBatchDeList() {
        if (this.selections.length == 0) {
            return
        }
        let ids = []
        this.selections.forEach(o => {
            ids.push(o.id)
        })
        this.serve.net_batch_deList(ids, this.action_page_demand)
    }

    handleTabClick(tab) {
        if(tab.name == 'A'){
            this.serve.m_search.status = ""
        } else if(tab.name == 'B'){
            this.serve.m_search.status = "1"
        }else if(tab.name == 'C'){
            this.serve.m_search.status = "3"
        }else if(tab.name == 'D'){
            this.serve.m_search.status = "0"
        }
        this.serve.m_search.pageNum = 1
        this.action_page_demand()
    }
}
